import React, { Component } from 'react'
import arrowRight from '../img/right-arrow.svg'
import arrowLeft from '../img/left-arrow.svg'
import educationData from '../educationData.json'



export default class Education extends Component {
    render() {
        return (
            <div className="education">
                
                  
                    <div className="education-content">
                        <div className="title">
                            <div className="title__img">
                                <img src={arrowLeft} height="25px" alt="arrow right"/>
                            </div>
                            <div className="title__heading">
                                <h1>Education</h1>
                            </div>
                            <div className="title__img">
                                <img src={arrowRight} height="25px" alt="arrow right"/>
                            </div>
                        </div>
                        <div className="education__timeline"></div>
                        {educationData.map((educationItem) => {
                        return (
                        <div key={educationItem.id} className="education-content__item">
                            <div className="education-content__date">
                                {educationItem.date}
                            </div>
                            <div className="education-content__info">
                                <div className="info__content info-content">
                                    <h3 className="info-content__heading">{educationItem.heading}</h3>
                                    <span className="info-content__date">{educationItem.date}</span>
                                    <p className="info-content__text">{educationItem.text}</p>
                                </div>
                            </div>
                       </div>
                        )
                    })}
                    </div>
                
            </div>
        )
    }
}
